@if (sortedDataChunks(); as dataChunks) {
  <lib-list-table
    [headers]="['', 'PY', 'CY', 'ΔPY', '', 'ΔPY%', '', 'L12M', '']"
    (libOutsideClick)="dismissSelected()"
  >
    @for (dataChunk of dataChunks; track dataChunk.id) {
      @let focusDataPoint = dataChunk.dataPoints | getDataPoint: focusParams();
      @let absoluteDataPoint = dataChunk.dataPoints | getDataPoint: absoluteGrowthParams();
      @let relativeDataPoint = dataChunk.dataPoints | getDataPoint: relativeGrowthParams();
      @let pyDataPoint = dataChunk.dataPoints | getDataPoint: pyParams();

      <tr
        [attr.data-sentiment]="focusDataPoint?.sentiment"
        [class.selected]="dataChunk === selectedDataChunk()"
        [class.highlighted]="focusDataPoint | dataPointMatch : highlightedIds()"
        [attr.style]="'view-transition-name: item' + dataChunk.id + ';'"
      >
        <td>
          <div class="title">
            <lib-direction-indicator [value]="focusDataPoint?.sentiment"/>
            {{ dataChunk.dimensionItems | dataChunkTitle: dimensionLevelName() }}
          </div>
        </td>
        <td class="number">
          {{ pyDataPoint?.value | formatByMeasure: focusMeasure() }}
        </td>
        <td class="number">
          {{ focusDataPoint?.value | formatByMeasure: focusMeasure() }}
        </td>
        <td class="number">
          {{ absoluteDataPoint?.value | formatByMeasure: focusMeasure()?.absoluteGrowthMeasure }}
        </td>
        <td class="bar-chart">
          <lib-bar-minichart
            [maxNegative]="absoluteMinMax()?.min"
            [maxPositive]="absoluteMinMax()?.max"
            [value]="absoluteDataPoint?.value"
            [isAligned]="focusMeasure()?.alignment === Alignment.Aligned"
          />
        </td>
        <td class="number">
          {{ relativeDataPoint?.value | formatByMeasure: focusMeasure()?.relativeGrowthMeasure }}
        </td>
        <td class="bar-chart">
          <lib-bar-minichart
            [maxNegative]="relativeMinMax()?.min"
            [maxPositive]="relativeMinMax()?.max"
            [value]="relativeDataPoint?.value"
            [isAligned]="focusMeasure()?.alignment === Alignment.Aligned"
          />
        </td>
        <td>
          <lib-l12m-line-chart
            [dataPoints]="dataChunk.dataPoints"
            [measure]="focusMeasure()"
            [period]="focusPeriod()"
            [date]="focusDate()"
            [range]="valueRange()"
            [isHighlighted]="focusDataPoint | dataPointMatch : highlightedIds()"
          />
        </td>
        <td class="action-btn">
          <button class="popover-btn" (click)="selectDataChunk(dataChunk)">
            <svg width="24" height="24" viewBox="0 0 18 18" fill="currentColor">
              <use [attr.xlink:href]="SvgSpriteIcon.ArrowDownSLine"></use>
            </svg>
          </button>
          @if (selectedDataChunk() === dataChunk) {
            <div class="popover-content"
                 [attr.data-sentiment]="(dataChunk.dataPoints | getDataPoint: focusParams())?.sentiment"
            >
              @if (perspective(); as perspective) {
                @if (totalPerspective(); as totalPerspective) {
                  <lib-report-button
                    [perspective]="dataChunk.isTotal ? totalPerspective : perspective"
                    [filterDimensions]="dataChunk.dimensionItems"
                    [options]="{
              focusMeasure: focusMeasure(),
              focusPeriod: focusPeriod()
            }"
                    [reportPath]="reportPath()"
                  />
                }
              }

              <lib-drilldown
                [dimensionItems]="dataChunk.dimensionItems"
                (drillDown)="handleDrilldown($event)"
              />
            </div>
          }
        </td>
      </tr>
    }
  </lib-list-table>
}
